export const MENU_OPTIONS = {
  CONTROL_POINT: 'controlPoint',
  EVENT: 'source',
  HOME: 'home',
  DEVICES: 'devices',
  MONITORING: 'monitoring',
  TIMELINE: 'timeline'
};